import React, { useState, useEffect } from "react";
import moment from "moment";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import { ReactComponent as StarIcon } from "../../../../../assets/icons/star.svg";
import { useSelector } from "react-redux";
import { notify } from "../../../../../util/helpers";
import PatientLoader from "../../../../common/PatientLoader";

const Star = ({ is_filled = false, date }) => {
  return (
    <span
      className="container-fluid p-2"
      style={{
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        justifyItems: "center",
        width: "fit-content",
      }}
    >
      <span
        style={{
          display: "block",
          margin: "0px",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
          justifyItems: "center",
          paddingBottom: "10%",
        }}
      >
        <StarIcon fill={is_filled ? "#FDA004" : "#808080"} />
      </span>
      <label className="muted-text">{date}</label>
    </span>
  );
};
const DBTStreak = (props) => {
  const { dbtLoading, dbterror, dbtData } = useSelector(
    (state) => state.assessment
  );
  const [streakData, setStreakData] = useState([]);

  useEffect(() => {
    if (dbtLoading) return;
    setStreakData(dbtData);
  }, [dbtLoading]);

  useEffect(() => {
    if (!dbterror) return;
    notify("Something went wrong while fetching DBT streak", "error");
  }, [dbterror]);

  return (
    <CardLayout
      style={{
        border: "8px solid transparent",
        boxSizing: "border-box",
        backgroundClip: "padding-box",
      }}
    >
      <div className="container-fluid w-100">
        <div className="d-flex justify-content-between mb-4 mt-3">
          <label style={{ fontSize: "1.3rem", display: "flex", gap: "10px" }}>
            DBT Diary Card Sessions
          </label>

          <small
            onClick={() => {
              props.setDBTContentTab();
            }}
            style={{
              color: "#395e9d",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            View all {">"}
          </small>
        </div>
      </div>
      {dbtLoading ? (
        <div className="container-fluid">
          <PatientLoader />
        </div>
      ) : (
        <div className="container-fluid w-100 mb-4 d-flex">
          {streakData.map((item, index) => {
            const temp = Object.entries(item)[0]; //* [["2023-09-29", false]] ->  ["2023-09-29", false]
            const date = moment(temp[0]).format("MMM D"); //* This is the date
            const value = temp[1]; //* This is the boolean value
            return <Star is_filled={value} date={date} key={index} />;
          })}
        </div>
      )}
    </CardLayout>
  );
};

export default DBTStreak;
